$(document).ready(function(){

  $("a").on('click', function(event) {
    let _hash = $(this).attr('href').charAt(0);

    if (_hash == "#") {
      event.preventDefault();

      var hash = this.hash;

      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 800, function(){

        window.location.hash = hash;
      });
    }
  });
});